import React from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import AerloLogo from 'static/images/aerlo-logo.svg';
import AerloLogoMobile from 'static/images/aerlo-logo-mobile.svg';
import PointAddress from 'static/images/point-address.svg';
import TelIcon from 'static/images/tel-icon.svg';
import EmailIcon from 'static/images/email.svg';
import './style.scss';
import clsx from 'clsx';

export const BannerAerlo = () => {
    const { t } = useTranslation();
    return (
        <div className={clsx('banner-aerlo', { 'mobile-banner': isMobile })}>
            <div className="banner-aerlo-content">
                <a href="http://lenoblinvest.ru/" target="_blank" rel="noopener noreferrer">
                    {isMobile
                        ? <AerloLogoMobile className="banner-aerlo-logo" />
                        : <AerloLogo className="banner-aerlo-logo" />}
                </a>

                <div className="banner-aerlo-address">
                    <PointAddress />
                    <span>
                        {t('Санкт-Петербург, Малоохтинский проспект, дом 64, литера Б, офис 402')}
                    </span>
                </div>
                <div className="banner-aerlo-tel">
                    <TelIcon />
                    <span>+ 7 (812) 644 01 23</span>
                </div>
                <a href="mailto:aerlo@lenoblinvest.ru" className="banner-aerlo-email">
                    <EmailIcon />
                    <span>aerlo@lenoblinvest.ru</span>
                </a>
            </div>

        </div>
    );
};
